export interface DeleteProjectReportModalProps {
  onCancel: () => void;
  onDelete: () => void;
  textContent: string;
  title: string;
}
